import { studyGroupMembershipApi } from "@/lib/humhub-api/studyGroupMembership";
import type { UserShort } from "@/lib/humhub-api/types";

export const DEFAULT_MEMBERSHIP_FETCH_PER_PAGE = 200;

export const fetchAllStudyGroupMembershipUsersByStatus = async (
  studyGroupId: number,
  membershipStatus: number,
  perPage = DEFAULT_MEMBERSHIP_FETCH_PER_PAGE,
): Promise<UserShort[]> => {
  const users = new Map<number, UserShort>();
  let page = 1;
  let pages = 1;

  do {
    const response = await studyGroupMembershipApi.getStudyGroupMemberships(
      studyGroupId,
      perPage,
      page,
      undefined,
      membershipStatus,
    );

    for (const membership of response.results) {
      const user = membership.user;
      if (user?.id) {
        users.set(user.id, user);
      }
    }

    pages = response.pages || 1;
    page += 1;
  } while (page <= pages);

  return Array.from(users.values());
};

export const fetchAllStudyGroupMemberIdsByStatus = async (
  studyGroupId: number,
  membershipStatus: number,
  perPage = DEFAULT_MEMBERSHIP_FETCH_PER_PAGE,
): Promise<number[]> => {
  const users = await fetchAllStudyGroupMembershipUsersByStatus(
    studyGroupId,
    membershipStatus,
    perPage,
  );
  return users.map((user) => user.id);
};
